import axios from '@/plugins/axios'
import * as actionTypes from '@/store/action-types'
import { FoodDatabaseState, GlobalState } from '@/types/state'
import FoodItem from '@/model/food-database/FoodItem'
import {FoodItemResponse} from '@/types/service-response'
import Allergen from "@/model/food-database/Allergen";
import Tag from "@/model/tennant/Tag";
import {debug} from "webpack";
import {DELETE_FOOD_ITEM_IMAGE} from "@/store/action-types";
import FoodItemImage from "@/model/food-database/FoodItemImage";

const state: FoodDatabaseState = {}

const getters = {}

const mutations = {}

const actions = {
  async [actionTypes.FOOD_DATABASE_CREATE_FOOD_ITEM] ({ rootState }: { rootState: GlobalState }, payload: FoodItem): Promise<FoodItem> {
    const response = await axios.post('/api/food-database/food-item', {
          price: payload.price ? payload.price : null,
          title: payload.name,
          description: payload.description ? payload.description : null,
          energy: payload.energy ? payload.energy + ' ' + payload.energyUnit : null,
          weight: payload.weight ? payload.weight : null,
          tags: payload.tags.map((tag: Tag) => tag.tagIri),
          allergens: payload.allergens.map((item: Allergen) => item.iri),
          recipe: payload.recipe ? payload.recipe : null
    })

    return FoodItem.createFromModel(response.data)
  },

  async [actionTypes.FOOD_DATABASE_UPDATE_FOOD_ITEM] ({ rootState }: { rootState: GlobalState }, payload: FoodItem): Promise<FoodItem> {
    const response = await axios.put(`/api/food-database/food-item/${payload.id}`, {
      price: payload.price ? payload.price : null,
      title: payload.name,
      description: payload.description ? payload.description : null,
      energy: payload.energy ? payload.energy + ' ' + payload.energyUnit : null,
      weight: payload.weight ? payload.weight : null,
      tags: payload.tags.map((tag: Tag) => tag.tagIri),
      allergens: payload.allergens.map((item: Allergen) => item.iri),
      recipe: payload.recipe ? payload.recipe : null
    })

    return FoodItem.createFromModel(response.data)
  },

  async [actionTypes.FOOD_DATABASE_FETCH_FOOD_ITEMS] (): Promise<FoodItem[] | void> {
    const response = await axios.get('/api/food-database/food-item')
    if(response.data) {
      return FoodItem.createFromResponse(response.data as FoodItemResponse)
    } else {
      return []
    }
  },

  async [actionTypes.FETCH_ALLERGEN_LIST] (): Promise<Allergen[] | void> {
    try {
      const response = await axios.get('/api/food-database/allergen')

      return Allergen.createFromResponse(response.data)
    } catch (e) {
    }
  },

  async [actionTypes.FETCH_FOOD_ITEM_DETAILS] ({}, foodItemId: number): Promise<FoodItem> {
    const response = await axios.get(`/api/food-database/food-item/${foodItemId}`)

    return response.data
  },

  async [actionTypes.SAVE_NEW_FOODITEM_IMAGE] ({},payload: any): Promise<FoodItemImage> {
    const response = await axios.post('/api/food-database/food-item-media',{
      data: payload.data,
      foodItem: payload.foodItem,
      order: payload.order
    })

    return FoodItemImage.createFromResponse(response.data)
  },

  async [actionTypes.FETCH_FOOD_ITEM_IMAGES] ({},payload: any ): Promise<any> {

    const response = await axios.get(`/api/food-database/food-item-media/${payload.id}/data`)

    return response.data
  },

  async [actionTypes.DELETE_FOOD_ITEM_IMAGE] ({  }, payload: any): Promise<void> {

    const response = await axios.delete(`${payload.id}`)

    return response.data

  },

  async [actionTypes.UPDATE_FOOD_ITEM_IMAGE] ({ }, payload: any): Promise<any> {
    const response = await axios.put(`${payload.id}`,{

      "order": payload.order
    })

    return response.data
  },
}

const foodDatabaseModule = {
  state,
  getters,
  mutations,
  actions
}

export default foodDatabaseModule
